module.exports = __webpack_public_path__ + "379cf948a6b24923d5f87a7f00b615e8.explore.svg";